import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../fetchData";
import { DEFAULT_STALE_TIME, DEFAULT_CACHE_TIME } from "../../../shared/constants";

export const useGetContentDetail = (contentKey) => {
    return useQuery({
        queryKey: ["cms", contentKey],
        queryFn: () => fetchData(`cms/${contentKey}`),
        enabled: !!contentKey,
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};


export const useGetFooterDetail = () => {
    return useQuery({
        queryKey: ["footer"],
        queryFn: () => fetchData(`footer`),
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};

export const useGetNavbarDetail = () => {
    return useQuery({
        queryKey: ["navbar"],
        queryFn: () => fetchData(`navbar`),
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};
